import React from "react";
import { Nav, Tab } from "react-bootstrap";
import {
  BsFillLightbulbFill,
  BsFillHouseDoorFill,
  BsMegaphoneFill,
  BsInboxFill,
  BsFillGearFill,
} from "react-icons/bs";
import { Link } from "react-router-dom";

const SideMenuNew = () => {
  return (
    <div className="brand-sidebar-main">
      <Nav variant="pills" className="flex-column">
        <Nav.Item className="sidebar-list-item">
          <Nav.Link eventKey="dashboard" as={Link} to="/brand/dashboard">
            <BsFillHouseDoorFill className="icon" /> Home
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="sidebar-list-item">
          <Nav.Link as={Link} to="/brand/campaigns" eventKey="campaigns">
            <BsMegaphoneFill className="icon" /> Campaigns
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="sidebar-list-item">
          <Nav.Link as={Link} to="/brand/analytics" eventKey="analytics">
            <BsFillLightbulbFill className="icon" /> Analytics
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="sidebar-list-item">
          <Nav.Link as={Link} to="/brand/inbox" eventKey="inbox">
            <BsInboxFill className="icon" /> Inbox
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="sidebar-list-item">
          <Nav.Link as={Link} to="/brand/account" eventKey="account">
            <BsFillGearFill className="icon" /> Account
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default SideMenuNew;
